import axios from "@util/axios.js";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const getAllDevices = async (page, items) => {
   let url = `${hostCloud}/old-device/all?page=${page}&items=${items}`;
   return axios({
      method: "get",
      url: url,
      headers: {
         Accept: "*/*"
      }
   });
};
export const getSingleDevice = async (id, date) => {
   let url = `${hostCloud}/old-device/single`;
   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*"
      },
      data: {
         deviceId: id,
         day: date
      }
   });
};
